// extracted by mini-css-extract-plugin
export var brand = "_7v-8";
export var compact = "_7v-5";
export var extraSmall = "_7v-6";
export var icon = "_7v-0";
export var large = "_7v-3";
export var light = "_7v-1";
export var medium = "_7v-4";
export var outline = "_7v-a";
export var primaryDark = "_7v-9";
export var primaryLight = "_7v-7";
export var primaryModern = "_7v-b";
export var success = "_7v-2";